<ee-help-collection
  [collection]="collection"
  (openArticle)="openArticle($event)"
  (back)="goHome()"
></ee-help-collection>
